import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 48%;
  max-width: 700px;
  height: 100%;
  background-image: linear-gradient(180deg, #585e66 0%, #42464c 100%);
`;

export const Labels = styled.span`
  position: absolute;
  color: #eff1f5;
  font-family: Sora;
  font-size: 0.75rem;
  font-weight: 400;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
`;
export const ChartContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
`;
export const Legenda = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};

  span {
    font-family: Sora;
    font-size: 0.75rem;
    font-weight: 400;
    color: #eff1f5;
  }
`;
export const LegendLine = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;
export const GreenMarble = styled.div`
  width: 8px;
  height: 8px;
  background: linear-gradient(127deg, #40e5a0 0%, #118052 100%);
  border-radius: 100%;
  margin-right: 0.25rem;
`;

export const WhiteMarble = styled.div`
  width: 8px;
  height: 8px;
  background: linear-gradient(180deg, #eff1f5 0%, #fff 100%);
  border-radius: 100%;
  margin-right: 0.25rem;
`;
